export const MAX_BOUNDS = 5;
